<template>
  <div id="app">
    <!-- <div
      v-if="
        account &&
        !account?.isEmailVerified &&
        ![EMAIL_VERIFICATION_WALL_ROUTE].includes(route)
      "
      class="row verify-email-alert"
    >
      <div class="col-12 text-center">
        <span
          >Please verify your email.
          <a v-on:click="requestVerification()">Send Email</a>
        </span>
      </div>
    </div> -->
    <!-- <div v-if="routerIsLoading" class="spinner-overlay">
      <div class="spinner">
        <img height="60" src="./assets/images/logo.webp" alt="" srcset="" />
      </div>
    </div> -->
    <router-view />
    <!-- The support chat with Screenkode (components/chat). -->
    <support-chat-widget v-if="showSupportChat" team-name="Screenkode" :team-logo="supportTeamLogo" />
    <pwa-install-prompt v-if="!isSupportSession" />
  </div>
  <!-- <div v-else class="container">
    <br />
    <div class="alert alert-secondary" role="alert">
      <h6 class="text-center">
        Content can not be displayed on small screens. Please use a larger
        screen.
      </h6>
    </div>
  </div> -->
</template>
<script>
import {
  LARGE_SCREEN_SIZE,
  DEFAULT_ERROR_MSG,
  TOAST_GLOBAL_CONFIG,
} from '@/utils/const';
import {
  CLEAR_ERRORMSG,
  REQUEST_EMAIL_VERIFICATION,
  GET_AUTH_ACCOUNT,
  GET_CUSTOM_FONTS,
} from '@/store/action_types';
import {
  EMAIL_VERIFICATION_WALL_ROUTE,
  DISPLAY_ROUTE,
  SCREEN_SCHEDULE_DISPLAY_ROUTE,
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  DONATIONS_N_ROUTE,
  ANNOUNCEMENTS_N_ROUTE,
  ZMANIM_N_ROUTE,
  ADD_ZMANIM_N_ROUTE,
  EDIT_ZMANIM_N_ROUTE,
  DUPLICATE_ZMANIM_N_ROUTE,
  MINYANIM_ROLLS_N_ROUTE,
  ADD_MINYANIM_ROLL_N_ROUTE,
  EDIT_MINYANIM_ROLL_N_ROUTE,
  DUPLICATE_MINYANIM_ROLL_N_ROUTE,
  ADD_ANNOUNCEMENT_ROUTE,
  EDIT_ANNOUNCEMENT_ROUTE,
  POSTERS_ROUTE,
  DATE_TIME_BANNER_ROUTE,
  SETTINGS_ROUTE,
} from '@/router/routes';
// Quill rendering styles (.ql-editor) used to render saved announcement / rich
// text content in live previews and on the Display. Kept global so the styles
// are present regardless of which route is active.
import '@vueup/vue-quill/dist/vue-quill.core.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import PwaInstallPrompt from '@/components/PwaInstallPrompt.vue';
import SupportChatWidget from '@/components/chat/Support_Chat_Widget.vue';
import supportTeamLogo from '@/assets/images/logo-icon.png';
import { isSupportSessionContext } from '@/utils/support_session';
import { startTicketUnreadPolling, stopTicketUnreadPolling } from '@/utils/ticket_notifications';

const APP_ZOOM_MIN_WIDTH = 1200;
const APP_ZOOM_CLASS = 'app-zoomed';

export default {
  components: {
    PwaInstallPrompt,
    SupportChatWidget,
  },
  data() {
    return {
      isLoading: false,
      LARGE_SCREEN_SIZE,
      EMAIL_VERIFICATION_WALL_ROUTE,
      DASHBOARD_ROUTE,
      LOGIN_ROUTE,
      DONATIONS_N_ROUTE,
      ANNOUNCEMENTS_N_ROUTE,
      ZMANIM_N_ROUTE,
      ADD_ZMANIM_N_ROUTE,
      EDIT_ZMANIM_N_ROUTE,
      DUPLICATE_ZMANIM_N_ROUTE,
      MINYANIM_ROLLS_N_ROUTE,
      ADD_MINYANIM_ROLL_N_ROUTE,
      EDIT_MINYANIM_ROLL_N_ROUTE,
      DUPLICATE_MINYANIM_ROLL_N_ROUTE,
      ADD_ANNOUNCEMENT_ROUTE,
      EDIT_ANNOUNCEMENT_ROUTE,
      POSTERS_ROUTE,
      DATE_TIME_BANNER_ROUTE,
      SETTINGS_ROUTE,
      windowWidth: 0,
      // In the Screenkode admin's frame, for a support session.
      isSupportSession: isSupportSessionContext(),
      supportTeamLogo,
    };
  },
  watch: {
    errorMessage: {
      handler(val) {
        if (val != null) {
          this.$toast.error(val ?? DEFAULT_ERROR_MSG, TOAST_GLOBAL_CONFIG);
          this.$store.dispatch(CLEAR_ERRORMSG);
        }
      },
    },
    // The uploaded fonts are org-wide, so the library is (re)fetched whenever
    // the signed-in organization becomes known or changes.
    organizationId: {
      immediate: true,
      handler() {
        this.loadCustomFonts();
      },
    },
    route: {
      immediate: true,
      handler() {
        this.syncAppZoom();
      },
    },
    // The unread ticket count (the badge on Tickets) is kept current for
    // whoever is signed in, and dropped when nobody is — or on the kiosk
    // pages, which are screens, not people.
    account: {
      immediate: true,
      handler() {
        this.syncTicketPolling();
      },
    },
    isDisplayRoute() {
      this.syncTicketPolling();
    },
  },
  computed: {
    route() {
      return this.$route.name;
    },
    // The kiosk pages: a screen's own link and a screen schedule's link. Both
    // run unauthenticated on a TV, outside the admin shell.
    isDisplayRoute() {
      return this.route === DISPLAY_ROUTE || this.route === SCREEN_SCHEDULE_DISPLAY_ROUTE;
    },
    account() {
      return this.$store.getters.account.data;
    },
    organizationId() {
      return (
        this.account?.organizationId ||
        this.$store.getters.organization?.data?.id ||
        this.account?.organization?.id ||
        null
      );
    },
    // The support chat button: on the signed-in pages (those behind the same
    // sign-in guard as the dashboard), for anyone in an organization — a
    // Screenkode staff account that belongs to one too, chatting as that
    // organization — but never inside one of the admin's support sessions.
    showSupportChat() {
      const account = this.account;
      if (!account || !(account.organizationId || account.organization?.id)) return false;
      if (!this.$store.getters.sessionToken || this.isSupportSession) return false;
      const dashboard = this.$router.getRoutes().find((record) => record.name === DASHBOARD_ROUTE);
      const signedInGuard = dashboard && dashboard.beforeEnter;
      return Boolean(signedInGuard) && this.$route.matched.some((record) => record.beforeEnter === signedInGuard);
    },
    accountIsLoading() {
      return this.$store.getters.account.isLoading;
    },
    routerIsLoading() {
      return this.$store.getters.routerIsLoading;
    },
    errorMessage() {
      return this.$store.getters.errorMsg;
    },
  },
  methods: {
    syncTicketPolling() {
      if (this.account && this.$store.getters.sessionToken && !this.isDisplayRoute) startTicketUnreadPolling(this.$store, this.$router);
      else stopTicketUnreadPolling();
    },
    requestVerification() {
      if (!this.accountIsLoading) {
        this.$store.dispatch(REQUEST_EMAIL_VERIFICATION).then((res) => {
          if (res) {
            this.$toast.info('Verification email sent.', TOAST_GLOBAL_CONFIG);
          }
        });
      }
    },
    getScreenSize() {
      this.windowWidth = window.innerWidth;
      this.syncAppZoom();
    },
    shouldUseAppZoom() {
      if (typeof window === 'undefined') return false;
      return !this.isDisplayRoute && window.innerWidth >= APP_ZOOM_MIN_WIDTH;
    },
    syncAppZoom() {
      if (typeof document === 'undefined') return;
      document.documentElement.classList.toggle(APP_ZOOM_CLASS, this.shouldUseAppZoom());
    },
    // The account (incl. its organization) is persisted to localStorage and only
    // ever captured at login, so it can go stale after org settings change (e.g.
    // Display Calendar Type). Refresh it once on boot when authenticated so the
    // whole app reads the current organization, not a frozen login snapshot.
    refreshAccountOnBoot() {
      const isAuthed = Boolean(this.$store.getters.sessionToken) && Boolean(this.account?.id);
      if (isAuthed && !this.accountIsLoading) {
        this.$store.dispatch(GET_AUTH_ACCOUNT);
      }
    },
    // Fetch the organization's uploaded typefaces once, here, rather than in
    // each editor: the store registers every face with the browser as the list
    // lands, so all the font pickers — and everything that renders their
    // output — are ready before any of them opens. The Display route runs
    // unauthenticated off a screen id and loads its own library (Display.vue).
    loadCustomFonts() {
      if (!this.organizationId || this.isDisplayRoute) return;
      this.$store.dispatch(GET_CUSTOM_FONTS, { organizationId: this.organizationId });
    },
  },
  created() {
    window.addEventListener('resize', this.getScreenSize);
    this.getScreenSize();
    this.refreshAccountOnBoot();
  },
  beforeUnmount() {
    stopTicketUnreadPolling();
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.getScreenSize);
    }
    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove(APP_ZOOM_CLASS);
    }
  },
};
</script>

<style lang="css">
@import './assets/style/index.css';
/* The support chat (components/chat). */
@import './assets/style/chat.css';
/* Support tickets (components/ticket, views/ticket) — here, not on the
   Tickets page, so the unread badges the navs wear are styled everywhere. */
@import './assets/style/ticket.css';

/* Blank lines in rich-text (announcement / etc.) content.
   The Tiptap editor serializes an authored blank line (pressing Enter) as an
   empty <p></p> with no <br> — which collapses to zero height when the saved
   HTML is rendered via v-html (in the live preview and on the Display /
   Dashboard), so the blank line disappears. Legacy Quill stored <p><br></p>,
   which still renders. Give truly-empty paragraphs a line box (a zero-width
   non-breaking placeholder) so authored blank lines show everywhere the
   content is rendered inside .ql-editor. Non-empty paragraphs and <p><br></p>
   are unaffected. */
.ql-editor p:empty::before {
  content: '\00a0';
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-left-color: var(--color-primary);
  animation: spin 1s linear infinite;
}

.verify-email-alert {
  background-color: var(--color-primary);
  color: #ffffff;
  padding-top: 3px;
  padding-bottom: 3px;
}

.verify-email-alert a {
  color: #ffffff;
  text-decoration: underline;
  font-size: 0.9rem;
  margin-left: 5px;
}

.verify-email-alert a:hover {
  cursor: pointer;
  text-decoration: underline;
}

.spinner img {
  height: 60px;
  z-index: 10; /* Ensures the image is above the spinner */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
